import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'arrayToComma',
    standalone: false
})
export class ArrayToCommaPipe implements PipeTransform {
  constructor() {
  }

  transform(value: string[] | null | undefined): any {
    if (value) {
      return _.join(value, ', ');
    }
    return value;
  }

}
